<template>
  <div>
    <div class="clearfix">
      <!--发票表格     start--->
      <div class="invoice_wrap fl">

        <!--空白发票在此标签，加类名 invoice_gray-->
        <div>
          <!--公共样式部分 发票类型 发票状态 灰层-->
          <div class="invoice_base">
            <p class="invoice_type"><span id="invoiceTypes">{{invoiceTypes}}</span></p>
            <span
              :class="['invoice_state',invoiceState]"
              id="invoiceState"
            ></span>
            <!--异常：abnormal，失控：outcontrol，红冲：red，作废：void-->

            <i class="iconfont icon-yinzhang check_result_icon"></i>
          </div>
          <h1 class="invoice_tit"><span><i id="invoiceTit">
                {{invoiceData.invoiceType || "增值税普通发票（卷票）"}}

              </i></span></h1>
          <ul class="invoice_top_info clearfix">
            <li>发票代码：<span><i
                  class="content_td_blue"
                  id="invoiceCode"
                >
                  {{invoiceData.invoiceCode || ""}}
                </i></span></li>
            <li>发票号码：<span><i
                  class="content_td_blue"
                  id="invoiceNumber"
                >
                  {{invoiceData.invoiceNumber || ""}}
                </i></span></li>
          </ul>
          <ul class="invoice_top_info_right invoice_top_info_right_roll clearfix">
            <li>校验码：<span><i
                  class="content_td_blue"
                  id="checkCode"
                >
                  {{invoiceData.checkCode || ""}}
                </i></span></li>
            <li>机器编号：<span><i
                  class="content_td_blue"
                  id="machineCode"
                >
                  {{invoiceData.machineCode || ""}}
                </i></span></li>
            <li>机打号码：<span
                class="content_td_blue"
                id="jdhm_invoiceNumber"
              >
                {{invoiceData.invoiceNumber || ""}}
              </span>
              开票日期：<span><i
                  class="content_td_blue"
                  id="billingDate"
                >{{farmatData(invoiceData.billingDate)}}</i></span></li>
          </ul>
          <table
            class="fppy_table"
            style="width: 100%;"
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <tbody>
              <tr>
                <td
                  width="20"
                  class="align_center"
                  rowspan="2"
                >
                  <p>销</p>
                  <p>售</p>
                  <p>方</p>
                </td>
                <td
                  width="120"
                  class="align_left borderNo"
                >销售方名称：
                </td>
                <td class="align_left borderNo bgcolorWhite"><span
                    class="content_td_blue"
                    id="salesName"
                  >
                    {{invoiceData.salesName || ""}}
                  </span>
                </td>
                <td
                  width="20"
                  class="align_center"
                  rowspan="2"
                >
                  <p>购</p>
                  <p>买</p>
                  <p>方</p>
                </td>
                <td
                  width="120"
                  class="align_left borderNo"
                >购买方名称：
                </td>
                <td class="align_left borderNo bgcolorWhite"><span
                    class="content_td_blue"
                    id="purchaserName"
                  >
                    {{invoiceData.purchaserName || ""}}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="align_left borderNo">纳税人识别号：</td>
                <td
                  class="align_left borderNo"
                  nowrap=""
                ><span
                    class="content_td_blue"
                    id="salesTaxNo"
                  >
                    {{invoiceData.salesTaxNo || ""}}
                  </span>
                </td>
                <td class="align_left borderNo">纳税人识别号：</td>
                <td
                  class="align_left borderNo"
                  nowrap=""
                ><span
                    class="content_td_blue"
                    id="purchaserTaxNo"
                  >
                    {{invoiceData.purchaserTaxNo || ""}}
                  </span>
                </td>
              </tr>
              <!--表头-->
              <tr>
                <td colspan="6">
                  <table
                    class="fppy_table_box"
                    style="width: 100%;"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tbody>
                      <tr height="30px">
                        <td
                          width="40%"
                          class="align_center borderRight"
                        >项目</td>
                        <td
                          width="20%"
                          class="align_center borderRight"
                        >单价</td>
                        <td
                          width="20%"
                          class="align_center borderRight"
                        >数量</td>
                        <td
                          width="20%"
                          class="align_center "
                        >金额</td>
                      </tr>
                      <tr height="20px">
                        <td
                          width="40%"
                          class="align_center borderRight"
                        ></td>
                        <td
                          width="20%"
                          class="align_center borderRight"
                        ></td>
                        <td
                          width="20%"
                          class="align_center borderRight"
                        ></td>
                        <td
                          width="20%"
                          class="align_center"
                        ></td>
                      </tr>
                      <!--{{invoiceData.purchaserTaxNo || ""}}-->
                      <tr
                        v-if="invoiceData.items && invoiceData.items.length > 8"
                        id="showGoodsListRow"
                      >
                        <td
                          class="align_left borderRight"
                          style="position: relative;"
                        >
                          <span class="content_td_blue">(详见销货清单)</span>
                          <a
                            href="javascript:;"
                            class="list_detail_btn"
                            id="goodsList"
                          >详见货物清单</a>
                        </td>
                        <td class="align_right borderRight"><span class="content_td_blue"></span></td>
                        <td class="align_right borderRight"><span class="content_td_blue"></span></td>
                        <td class="align_right"><span class="content_td_blue"></span></td>
                      </tr>

                      <tr
                        class="invoice_shop_list"
                        v-for="(item,index) in invoiceData.items"
                        :key="index"
                        :class="['invoice_shop_list',displayNone]"
                      >
                        <td class="align_center borderRight"><span class="content_td_blue commodityName">
                            {{item.commodityName}}
                          </span></td>
                        <td class="align_center borderRight"><span class="content_td_blue unitPrice">
                            {{item.unitPrice}}
                          </span></td>
                        <td class="align_center borderRight"><span class="content_td_blue quantity">
                            {{item.quantity}}
                          </span>
                        </td>
                        <td class="align_center"><span class="content_td_blue amount">
                            {{item.amount}}
                          </span>
                        </td>
                      </tr>

                      <tr height="40px">
                        <td
                          width="40%"
                          class="align_center borderRight"
                        ></td>
                        <td
                          width="20%"
                          class="align_center borderRight"
                        ></td>
                        <td
                          width="20%"
                          class="align_center borderRight"
                        ></td>
                        <td
                          width="20%"
                          class="align_center"
                        ></td>
                      </tr>

                      <tr>
                        <td
                          class=" borderRight borderTop invoiceRoll_btm"
                          colspan="4"
                        >
                          <span>价税合计（小写）</span>
                          <span
                            class="content_td_blue"
                            id="amountTax"
                          >
                            ￥ {{invoiceData.amountTax || ""}}
                          </span>
                          <span>价税合计（大写）</span>
                          <span
                            class="content_td_blue"
                            id="amountTaxCn"
                          >
                            ⊗ {{invoiceData.amountTaxCn || ""}}
                          </span>
                          <span>收款员</span>
                          <span
                            class="content_td_blue"
                            id="payee"
                          >
                            {{invoiceData.receivingClerk || ""}}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <!--表头结束-->
            </tbody>
          </table>

        </div>

      </div>
      <!--发票表格     end--->
    </div>

    <van-popup
      v-model="visible"
      closeable
      :style="{ width: '94%' }"
    >
      <InvoiceRollDetail :invoiceData="invoiceData" />
    </van-popup>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'InvoiceRoll',
  data() {
    return {
      visible: false,
      displayNone: '',
    };
  },
  props: ['invoiceData', 'invoiceState', 'invoiceTypes', 'invoiceTit'],
  created() {
    if (this.invoiceData && this.invoiceData.items && this.invoiceData.items.length >= 8) {
      this.displayNone = 'displayNone';
    }
  },
  methods: {
    farmatData(date) {
      if (!date) return '';
      console.log('date===', date);
      return moment(date).format('YYYY 年 MM 月 DD 日');
    },
  },
};
</script>
<style scoped  src="../invoice.css"></style>
<style scoped  src="../checkResult.css"></style>
<style  scoped>
.invoice_wrap {
  font-size: 10px;
}
</style>
